import { createFileRoute } from '@tanstack/react-router'
import { CreditNotePrintPage } from '../../../../features/sales/credit-note-print-page'

export const Route = createFileRoute('/_app/credit-notes/$creditNoteId/print')({
  staticData: { crumb: 'creditNotePrint' },
  component: CreditNotePrintPage,
})
